import { render, staticRenderFns } from "./MyHistoryMobile.vue?vue&type=template&id=ad70765e&scoped=true"
import script from "./MyHistoryMobile.vue?vue&type=script&lang=js"
export * from "./MyHistoryMobile.vue?vue&type=script&lang=js"
import style0 from "./MyHistoryMobile.vue?vue&type=style&index=0&id=ad70765e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad70765e",
  null
  
)

export default component.exports